import { render } from "./DocumentLocatorTestingForm.vue?vue&type=template&id=49b235a3&scoped=true&ts=true"
import script from "./DocumentLocatorTestingForm.vue?vue&type=script&lang=ts"
export * from "./DocumentLocatorTestingForm.vue?vue&type=script&lang=ts"

import "./DocumentLocatorTestingForm.vue?vue&type=style&index=0&id=49b235a3&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b235a3"]])

export default __exports__